/* eslint-disable import/prefer-default-export, react/prop-types */
import React from "react";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import Site from "@parallelpublicworks/gatsby-clf/src/Site";
import { registerThemeComponents } from "@parallelpublicworks/clf-utils/componentRegistry";
import { registerChildComponents } from "./registerChildComponents";

registerThemeComponents();
registerChildComponents();

// Create Emotion cache with the same key as in gatsby-ssr.js
const key = "clf";
const cache = createCache({ key });

export const wrapRootElement = ({ element }) => {
	return <CacheProvider value={cache}>{element}</CacheProvider>;
};

export const wrapPageElement = ({ element, props }) => {
	return <Site element={element} props={props} />;
};
